import { render, staticRenderFns } from "./ValidityCheckerTable.vue?vue&type=template&id=64682eb4"
import script from "./ValidityCheckerTable.vue?vue&type=script&lang=js"
export * from "./ValidityCheckerTable.vue?vue&type=script&lang=js"
import style0 from "./ValidityCheckerTable.vue?vue&type=style&index=0&id=64682eb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports